import {
  Box,
  Collapse,
  Flex,
  HStack,
  Image,
  Text,
  useDisclosure,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  useMediaQuery,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import administration from "../../img/administration.svg";
import deferredAdmissions from "../../img/admissionsde.svg";
import alumni from "../../img/alumniad.svg";
import badge from "../../img/badge.svg";
import calendar from "../../img/calendarad.svg";
import center from "../../img/center.svg";
import courses from "../../img/coursesad.svg";
import coursesnew from "../../img/coursesnew.svg";
import dashboard from "../../img/dashboardad.svg";
import discipline from "../../img/disciplinead.svg";
import drafts from "../../img/drafts.svg";
import modules from "../../img/modulesad.svg";
import naptinlogo from "../../img/naptinlogo.png";
import pendingRe from "../../img/pendingad.svg";
import posting from "../../img/posting.svg";
import program from "../../img/programsad.svg";
import rolesRe from "../../img/roles.svg";
import session from "../../img/session.svg";
import shortlisted from "../../img/shortlisted.svg";
import technicality from "../../img/technicality.svg";
import traineeRe from "../../img/traineere.svg";
import trainee from "../../img/traineesad.svg";
import trainerRe from "../../img/trainerre.svg";
import Adminroutes from "../../pages/admin/routes";

import assignedbadge from "../../img/assignedbadge.svg";
import results from "../../img/results.svg";
import sponsors from "../../img/sponsors.svg";
import surveyRe from "../../img/surveyre.svg";

import { BiBadge } from "react-icons/bi";
import { HiSpeakerphone } from "react-icons/hi";
import { MdKeyboardArrowDown } from "react-icons/md";
import { RiMenu3Line } from "react-icons/ri";

const AdminSidebar = () => {
  const location = useLocation();
  // const [showDropdown, setShowDropdown] = useState(false);
  const { isOpen: isOpenUsers, onToggle: onToggleUsers } = useDisclosure();
  const { isOpen: isOpenBadge, onToggle: onToggleBadge } = useDisclosure();
  const { isOpen: isOpenAdmin, onToggle: onToggleAdmin } = useDisclosure();
  const { isOpen: isOpenCourseMgt, onToggle: onToggleCourseMgt } =
    useDisclosure();

  const [isLargerThan768] = useMediaQuery("(min-width: 980px)");

  const [drawerOpen, setDrawerOpen] = useState(false);

  const activeLink = (link: string) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (link === location.pathname) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <>
      {/* Drawer for smaller screens */}
      {!isLargerThan768 && (
        <Box
          maxHeight={"100vh"}
          width={"100%"}
          pt="1rem"
          px="0.5rem"
          borderRight="0.7px solid"
          borderColor="#E5E5E5"
          display={"flex"}
          justifyContent={"center"}
          bg="white"
        >
          <RiMenu3Line
            onClick={handleDrawerOpen}
            width={"50px"}
            height={"50px"}
            fontSize={"30px"}

          />
          <Drawer
            isOpen={drawerOpen}
            placement="left"
            onClose={handleDrawerClose}
          >
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader>Menu</DrawerHeader>
              <DrawerBody>
                {/* Render your menu items here */}
                <HStack spacing="10px" mb="10px">
                  <Box as="span" pb="5px">
                    <Image src={dashboard} width="18px" height="18px" />
                  </Box>
                  <Box
                    // mb="20px"
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                  >
                    <Link to={Adminroutes.Dashboard}>Dashboard</Link>
                  </Box>
                </HStack>
                <HStack
                  spacing="10px"
                  mb="10px"
                  color="#616161"
                  cursor="pointer"
                  onClick={onToggleCourseMgt}
                >
                  <Box as="span" pb="5px">
                    <Image src={courses} width="18px" height="18px" />
                  </Box>
                  <Box
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                  >
                    <Text>Programs & Courses</Text>
                  </Box>
                  <Box as="span">
                    {" "}
                    <MdKeyboardArrowDown fontSize={18} />
                  </Box>
                </HStack>

                <Collapse in={isOpenCourseMgt}>
                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image src={program} width="18px" height="18px" />
                    </Box>
                    <Box
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Programs}>Programs</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image src={modules} width="18px" height="18px" />
                    </Box>
                    <Box
                      // ml="30px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.program_modules}>Modules</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image src={coursesnew} width="18px" height="18px" />
                    </Box>
                    <Box
                      // ml="30px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Courses}>Courses</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image src={technicality} width="18px" height="18px" />
                    </Box>
                    <Box
                      // ml="30px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.CourseTechnicality}>
                        Course Technicality
                      </Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image src={discipline} width="18px" height="18px" />
                    </Box>
                    <Box
                      // ml="30px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.DisciplineSpecialization}>
                        Discipline & Specialization
                      </Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image src={posting} width="18px" height="18px" />
                    </Box>
                    <Box
                      // ml="30px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.ManagePostings}>
                        Manage Postings
                      </Link>
                    </Box>
                  </HStack>

                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image src={drafts} width="18px" height="18px" />
                    </Box>
                    <Box
                      // ml="30px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.CourseDraft}>Drafts</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="10px">
                    <Box as="span" pb="5px">
                      <Image
                        src={deferredAdmissions}
                        width="18px"
                        height="18px"
                      />
                    </Box>
                    <Box
                      // ml="30px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.DeferredAdmissions}>
                        Deferred Admissions
                      </Link>
                    </Box>
                  </HStack>
                </Collapse>
                <HStack
                  spacing="10px"
                  mb="10px"
                  cursor={"pointer"}
                  onClick={onToggleUsers}
                >
                  <Box as="span" pb="5px">
                    <Image src={trainee} width="20px" height="20px" />
                  </Box>
                  <Box
                    // mb="20px"
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                    cursor={"pointer"}
                  >
                    <Text>Users Management</Text>
                  </Box>
                  <Box as="span">
                    {" "}
                    <MdKeyboardArrowDown fontSize={18} color="#616161" />
                  </Box>
                </HStack>
                <Collapse in={isOpenUsers}>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={traineeRe} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Trainees}>Trainees</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={trainerRe} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Trainer}>Trainers</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={coursesnew} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.UserRoles}>Staff</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={alumni} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Alumni}>Alumni</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={pendingRe} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Review}>Pending Reviews</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={shortlisted} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.ShortlistedApplicants}>
                        Shortlisted Applicants
                      </Link>
                    </Box>
                  </HStack>
                </Collapse>
                <HStack
                  spacing="10px"
                  mb="10px"
                  color="#616161"
                  cursor="pointer"
                  onClick={onToggleAdmin}
                >
                  {/* <Box as="span" pb="5px">
          <BiUserCircle fontSize={"20px"} />
        </Box> */}
                  <Box as="span" pb="5px">
                    <Image src={administration} width="20px" height="20px" />
                  </Box>
                  <Box
                    // mb="20px"
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                  >
                    <Text>Administration</Text>
                  </Box>
                  <Box as="span">
                    {" "}
                    <MdKeyboardArrowDown fontSize={18} />
                  </Box>
                </HStack>
                <Collapse in={isOpenAdmin}>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    {/* <Box as="span" pb="5px">
            <IoLocationOutline />
          </Box> */}
                    <Box as="span" pb="5px">
                      <Image src={center} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Centers}>Center Management</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={posting} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Report}>Report</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px" color="#616161">
                    <Box as="span" pb="5px">
                      {/* <Image src={announcement} width="18px" height="18px" /> */}
                      <HiSpeakerphone fontSize={"18px"} />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.AdminAnnouncements}>
                        Announcement
                      </Link>
                    </Box>
                  </HStack>

                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={calendar} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Calendar}>Calendar</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={rolesRe} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Roles}>Roles</Link>
                    </Box>
                  </HStack>

                  <HStack ml="20px" spacing="10px" mb="5px">
                    <Box as="span" pb="5px">
                      <Image src={session} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Sessions}>Session & Term</Link>
                    </Box>
                  </HStack>
                  {/* <HStack ml="20px" spacing="10px" mb="5px">
          <Box as="span" pb="5px">
            <Image src={settings} width="18px" height="18px" />
          </Box>
          <Box
            // mb="20px"
            pb="5px"
            fontSize="14px"
            width="100%"
            borderBottom="0.7px solid"
            borderColor="#E5E5E5"
            color="#616161"
          >
            <Link to={Adminroutes.AuditTrails}>Audit Trail</Link>
          </Box>
        </HStack> */}
                </Collapse>

                <HStack
                  spacing="10px"
                  mb="10px"
                  color="#616161"
                  cursor="pointer"
                  onClick={onToggleBadge}
                >
                  <Box as="span" pb="5px">
                    <BiBadge fontSize={"20px"} />
                  </Box>
                  {/* <Box as="span" pb="5px">
          <Image src={budget} width="18px" height="18px" />
        </Box> */}
                  <Box
                    // mb="20px"
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                  >
                    <Text>Badge Management</Text>
                  </Box>
                  <Box as="span">
                    {" "}
                    <MdKeyboardArrowDown fontSize={18} />
                  </Box>
                </HStack>
                <Collapse in={isOpenBadge}>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    {/* <Box as="span" pb="5px">
            <BiBadge color="#616161" fontSize={"22px"} />
          </Box> */}
                    <Box as="span" pb="5px">
                      <Image src={badge} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.Badges}>Badges</Link>
                    </Box>
                  </HStack>
                  <HStack ml="20px" spacing="10px" mb="5px">
                    {/* <Box as="span" pb="5px">
            <BiBadgeCheck color="#616161" fontSize={"22px"} />
          </Box> */}
                    <Box as="span" pb="5px">
                      <Image src={assignedbadge} width="18px" height="18px" />
                    </Box>
                    <Box
                      // mb="20px"
                      pb="5px"
                      fontSize="14px"
                      width="100%"
                      borderBottom="0.7px solid"
                      borderColor="#E5E5E5"
                      color="#616161"
                    >
                      <Link to={Adminroutes.AssignedBadges}>
                        Assigned Badges
                      </Link>
                    </Box>
                  </HStack>
                </Collapse>

                <HStack spacing="10px" mb="10px">
                  {/* <Box as="span" pb="5px">
          <BsBook />
        </Box> */}
                  <Box as="span" pb="5px">
                    <Image src={results} width="20px" height="20px" />
                  </Box>
                  <Box
                    // mb="20px"
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                  >
                    <Link to={Adminroutes.AdminResult}>Results</Link>
                  </Box>
                </HStack>
                <HStack spacing="10px" mb="10px">
                  <Box as="span" pb="5px">
                    <Image src={surveyRe} width="20px" height="20px" />
                  </Box>
                  <Box
                    // mb="20px"
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                  >
                    <Link to={Adminroutes.ViewSurvey}>Survey</Link>
                  </Box>
                </HStack>
                <HStack spacing="10px" mb="10px">
                  <Box as="span" pb="5px">
                    <Image src={sponsors} width="20px" height="20px" />
                  </Box>
                  <Box
                    // mb="20px"
                    pb="5px"
                    fontSize="16px"
                    width="100%"
                    borderBottom="0.7px solid"
                    borderColor="#E5E5E5"
                    color="#616161"
                  >
                    <Link to={Adminroutes.sponsor.SponsorDashboard}>
                      Sponsors
                    </Link>
                  </Box>
                </HStack>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </Box>
      )}

      {isLargerThan768 && (
        <Box
          bg="white"
          px="10px"
          borderRight="1px solid"
          height="100vh"
          borderColor="lightgray"
          className="sidebar"
        >
          <Flex ml="5px" pt="25px" mb="40px" alignItems="center">
            <Box as="span">
              <Image src={naptinlogo} height="45px" />
            </Box>
          </Flex>

          <HStack spacing="10px" mb="10px">
            <Box as="span" pb="5px">
              <Image src={dashboard} width="18px" height="18px" />
            </Box>
            <Box
              // mb="20px"
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
            >
              <Link to={Adminroutes.Dashboard}>Dashboard</Link>
            </Box>
          </HStack>
          <HStack
            spacing="10px"
            mb="10px"
            color="#616161"
            cursor="pointer"
            onClick={onToggleCourseMgt}
          >
            <Box as="span" pb="5px">
              <Image src={courses} width="18px" height="18px" />
            </Box>
            <Box
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
            >
              <Text>Programs & Courses</Text>
            </Box>
            <Box as="span">
              {" "}
              <MdKeyboardArrowDown fontSize={18} />
            </Box>
          </HStack>

          <Collapse in={isOpenCourseMgt}>
            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={program} width="18px" height="18px" />
              </Box>
              <Box
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Programs}>Programs</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={modules} width="18px" height="18px" />
              </Box>
              <Box
                // ml="30px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.program_modules}>Modules</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={coursesnew} width="18px" height="18px" />
              </Box>
              <Box
                // ml="30px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Courses}>Courses</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={technicality} width="18px" height="18px" />
              </Box>
              <Box
                // ml="30px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.CourseTechnicality}>
                  Course Technicality
                </Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={discipline} width="18px" height="18px" />
              </Box>
              <Box
                // ml="30px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.DisciplineSpecialization}>
                  Discipline & Specialization
                </Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={posting} width="18px" height="18px" />
              </Box>
              <Box
                // ml="30px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.ManagePostings}>Manage Postings</Link>
              </Box>
            </HStack>

            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={drafts} width="18px" height="18px" />
              </Box>
              <Box
                // ml="30px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.CourseDraft}>Drafts</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="10px">
              <Box as="span" pb="5px">
                <Image src={deferredAdmissions} width="18px" height="18px" />
              </Box>
              <Box
                // ml="30px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.DeferredAdmissions}>
                  Deferred Admissions
                </Link>
              </Box>
            </HStack>
          </Collapse>
          <HStack
            spacing="10px"
            mb="10px"
            cursor={"pointer"}
            onClick={onToggleUsers}
            color="#616161"
          >
            <Box as="span" pb="5px">
              <Image src={trainee} width="20px" height="20px" />
            </Box>
            <Box
              // mb="20px"
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
              cursor={"pointer"}
            >
              <Text>Users Management</Text>
            </Box>
            <Box as="span">
              {" "}
              <MdKeyboardArrowDown fontSize={18} color="#616161" />
            </Box>
          </HStack>
          <Collapse in={isOpenUsers}>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={traineeRe} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Trainees}>Trainees</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={trainerRe} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Trainer}>Trainers</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={coursesnew} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.UserRoles}>Staff</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={alumni} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Alumni}>Alumni</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={pendingRe} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Review}>Pending Reviews</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={shortlisted} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.ShortlistedApplicants}>
                  Shortlisted Applicants
                </Link>
              </Box>
            </HStack>
          </Collapse>
          <HStack
            spacing="10px"
            mb="10px"
            color="#616161"
            cursor="pointer"
            onClick={onToggleAdmin}
          >
            {/* <Box as="span" pb="5px">
          <BiUserCircle fontSize={"20px"} />
        </Box> */}
            <Box as="span" pb="5px">
              <Image src={administration} width="20px" height="20px" />
            </Box>
            <Box
              // mb="20px"
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
            >
              <Text>Administration</Text>
            </Box>
            <Box as="span">
              {" "}
              <MdKeyboardArrowDown fontSize={18} />
            </Box>
          </HStack>
          <Collapse in={isOpenAdmin}>
            <HStack ml="20px" spacing="10px" mb="5px">
              {/* <Box as="span" pb="5px">
            <IoLocationOutline />
          </Box> */}
              <Box as="span" pb="5px">
                <Image src={center} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Centers}>Center Management</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={posting} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Report}>Report</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px" color="#616161">
              <Box as="span" pb="5px">
                {/* <Image src={announcement} width="18px" height="18px" /> */}
                <HiSpeakerphone fontSize={"18px"} />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.AdminAnnouncements}>Announcement</Link>
              </Box>
            </HStack>

            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={calendar} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Calendar}>Calendar</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={rolesRe} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Roles}>Roles</Link>
              </Box>
            </HStack>

            <HStack ml="20px" spacing="10px" mb="5px">
              <Box as="span" pb="5px">
                <Image src={session} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Sessions}>Session & Term</Link>
              </Box>
            </HStack>

        <HStack ml="20px" spacing="10px" mb="5px">
          <Box as="span" pb="5px">
            <Image src={calendar} width="18px" height="18px" />
          </Box>
          <Box
            // mb="20px"
            pb="5px"
            fontSize="14px"
            width="100%"
            borderBottom="0.7px solid"
            borderColor="#E5E5E5"
            color="#616161"
          >
            <Link to={Adminroutes.AdminTrainingCalendar}>
              Training Calendar
            </Link>
          </Box>
        </HStack>
            {/* <HStack ml="20px" spacing="10px" mb="5px">
          <Box as="span" pb="5px">
            <Image src={settings} width="18px" height="18px" />
          </Box>
          <Box
            // mb="20px"
            pb="5px"
            fontSize="14px"
            width="100%"
            borderBottom="0.7px solid"
            borderColor="#E5E5E5"
            color="#616161"
          >
            <Link to={Adminroutes.AuditTrails}>Audit Trail</Link>
          </Box>
        </HStack> */}
          </Collapse>

          <HStack
            spacing="10px"
            mb="10px"
            color="#616161"
            cursor="pointer"
            onClick={onToggleBadge}
          >
            <Box as="span" pb="5px">
              <BiBadge fontSize={"20px"} />
            </Box>
            {/* <Box as="span" pb="5px">
          <Image src={budget} width="18px" height="18px" />
        </Box> */}
            <Box
              // mb="20px"
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
            >
              <Text>Badge Management</Text>
            </Box>
            <Box as="span">
              {" "}
              <MdKeyboardArrowDown fontSize={18} />
            </Box>
          </HStack>
          <Collapse in={isOpenBadge}>
            <HStack ml="20px" spacing="10px" mb="5px">
              {/* <Box as="span" pb="5px">
            <BiBadge color="#616161" fontSize={"22px"} />
          </Box> */}
              <Box as="span" pb="5px">
                <Image src={badge} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.Badges}>Badges</Link>
              </Box>
            </HStack>
            <HStack ml="20px" spacing="10px" mb="5px">
              {/* <Box as="span" pb="5px">
            <BiBadgeCheck color="#616161" fontSize={"22px"} />
          </Box> */}
              <Box as="span" pb="5px">
                <Image src={assignedbadge} width="18px" height="18px" />
              </Box>
              <Box
                // mb="20px"
                pb="5px"
                fontSize="14px"
                width="100%"
                borderBottom="0.7px solid"
                borderColor="#E5E5E5"
                color="#616161"
              >
                <Link to={Adminroutes.AssignedBadges}>Assigned Badges</Link>
              </Box>
            </HStack>
          </Collapse>

          <HStack spacing="10px" mb="10px">
            {/* <Box as="span" pb="5px">
          <BsBook />
        </Box> */}
            <Box as="span" pb="5px">
              <Image src={results} width="20px" height="20px" />
            </Box>
            <Box
              // mb="20px"
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
            >
              <Link to={Adminroutes.AdminResult}>Results</Link>
            </Box>
          </HStack>
          <HStack spacing="10px" mb="10px">
            <Box as="span" pb="5px">
              <Image src={surveyRe} width="20px" height="20px" />
            </Box>
            <Box
              // mb="20px"
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
            >
              <Link to={Adminroutes.ViewSurvey}>Survey</Link>
            </Box>
          </HStack>
          <HStack spacing="10px" mb="10px">
            <Box as="span" pb="5px">
              <Image src={sponsors} width="20px" height="20px" />
            </Box>
            <Box
              // mb="20px"
              pb="5px"
              fontSize="16px"
              width="100%"
              borderBottom="0.7px solid"
              borderColor="#E5E5E5"
              color="#616161"
            >
              <Link to={Adminroutes.sponsor.SponsorDashboard}>Sponsors</Link>
            </Box>
          </HStack>
        </Box>
      )}
    </>
  );
};

export default AdminSidebar;
